import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { baseUrl } from 'Utils/envLoader';
import UserService from 'Services/UserService';
import { Link } from 'react-router-dom';
import { Breadcrumb, Button } from 'react-bootstrap';

import IconTrueOrFalse from 'Components/Shared/IconTrueOrFalse';

import { AiOutlinePlusCircle } from 'react-icons/ai';

import { BsShieldLock, BsLock, BsUnlock, BsFillEnvelopeFill } from 'react-icons/bs';
import { FiEdit } from 'react-icons/fi';
import { toast } from 'react-toastify';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

import { getDirectAuth } from 'Services/AuthService';
import TableTemplate, { CellWrapper } from 'Components/Shared/datatable/tableTemplate';
import CustomModal from 'Components/UI/CustomModal';
import ForcingAuth from 'Components/Shared/ForcingAuth';
import DWTSecretArea from 'Components/Shared/DWTSecretArea';
import { getSDWT } from 'Utils/Helpers';

const Apps = () => {
    const [users, setUsers] = useState([]);
    const [forcedAuth, setForcedAuth] = useState(null);
    const [showForcingAuth, setShowForcingAuth] = useState(false);

    useEffect(() => {
        axios
            .get(`${baseUrl}/cliami/users`)
            .then((result) => {
                if (result.status === 200) {
                    setUsers(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    const DirectAuth = async (userRow) => {
        try {
            const token = await getDirectAuth(userRow.userId);
            setForcedAuth({ user: userRow, token });
            setShowForcingAuth(true);
        } catch (err) {
            toast.error(err.message ?? "Une erreur s'est produite !");
        } finally {
        }
    };

    const closeDWTModal = () => {
        setForcedAuth(null);
        setShowForcingAuth(false);
    };

    const disable = (userId) => {
        UserService.toggleDisableUser(userId)
            .then((response) => {
                const userInfo = response.data;
                const usersList = [...users];
                const index = usersList.findIndex((d) => d.userId == userInfo.userId);
                usersList[index] = userInfo;
                setUsers(usersList);
                toast.success('Action a été exécutée avec succès.');
            })
            .catch((ex) => {
                console.log(ex);
                toast.error("Une erreur s'est produite !");
            });
    };

    const sendInit = (userId) => {
        UserService.forceUser2Init(userId)
            .then((response) => {
                const userInfo = response.data;
                const usersList = [...users];
                const index = usersList.findIndex((d) => d.userId == userInfo.userId);
                usersList[index] = userInfo;
                setUsers(usersList);
                toast.success('Action a été exécutée avec succès.');
            })
            .catch((ex) => {
                console.log(ex);
                toast.error("Une erreur s'est produite !");
            });
    };

    const columns = React.useMemo(
        () => [
            {
                Header: 'UUID',
                accessor: 'userId',
                show: false,
            },
            {
                Header: 'Admin',
                accessor: (d) => (d.admin ? 1 : 0),
                Cell: ({ row: { original } }) => (
                    <CellWrapper position="center">
                        <IconTrueOrFalse value={original.admin} />
                    </CellWrapper>
                ),
                disableFilters: true,
            },
            {
                Header: 'First Name',
                accessor: 'firstName',
                filter: 'fuzzyText',
            },
            {
                Header: 'Last Name',
                accessor: 'lastName',
                filter: 'fuzzyText',
            },
            {
                Header: 'UserName',
                accessor: 'userName',
                filter: 'fuzzyText',
            },
            {
                Header: 'Email',
                accessor: 'email',
                filter: 'fuzzyText',
                Cell: ({ row: { values, original } }) => (
                    <>
                        {values.email}
                        <i
                            style={{
                                fontSize: '7pt',
                                display: 'block',
                                fontStyle: 'normal',
                            }}
                        >
                            {original.userId}
                        </i>
                    </>
                ),
            },
            {
                Header: 'Fonction',
                accessor: 'fonction.name',
                filter: 'fuzzyText',
                Cell: ({ row: { original } }) => <>{original.fonction?.name}</>,
            },
            {
                Header: 'isActive',
                accessor: (d) => (d.active ? 1 : 0),
                Cell: ({ row: { original } }) => (
                    <CellWrapper position="center">
                        <IconTrueOrFalse value={original.active} />
                    </CellWrapper>
                ),
                disableFilters: true,
            },
            {
                Header: 'isDisabled',
                accessor: (d) => (d.disabled ? 1 : 0),
                Cell: ({ row: { original } }) => (
                    <CellWrapper position="center">
                        <IconTrueOrFalse value={original.disabled} />
                    </CellWrapper>
                ),
                disableFilters: true,
            },
            {
                Header: 'Access',
                accessor: 'action-access',
                Cell: ({ row: { original } }) => (
                    <CellWrapper position="center">
                        <Link to={`/admin/access/user/${original.userId}`}>
                            <BsShieldLock
                                style={{
                                    fontSize: '16pt',
                                    color: 'black',
                                }}
                            />
                        </Link>
                    </CellWrapper>
                ),
                disableFilters: true,
                disableSortBy: true,
            },
            {
                Header: 'Edit',
                accessor: 'action-edit',
                Cell: ({ row: { original } }) => (
                    <CellWrapper position="center">
                        <Link to={`/admin/user/edit/${original.userId}`}>
                            <FiEdit
                                style={{
                                    fontSize: '16pt',
                                    color: 'black',
                                }}
                            />
                        </Link>
                    </CellWrapper>
                ),
                disableFilters: true,
                disableSortBy: true,
            },
            {
                Header: 'Init',
                accessor: 'action-init',
                Cell: ({ row: { original } }) => (
                    <CellWrapper position="center">
                        <Link to="#" as={Button} onClick={() => sendInit(original.userId)}>
                            <BsFillEnvelopeFill
                                style={{
                                    fontSize: '16pt',
                                    color: 'green',
                                }}
                            />
                        </Link>
                    </CellWrapper>
                ),
                disableFilters: true,
                disableSortBy: true,
            },
            {
                Header: 'Disable',
                accessor: 'action-disable',
                Cell: ({ row: { original } }) => (
                    <CellWrapper position="center">
                        <Link to="#" as={Button} onClick={() => disable(original.userId)}>
                            {original.disabled === true ? (
                                <BsUnlock
                                    style={{
                                        fontSize: '16pt',
                                        color: 'blue',
                                    }}
                                />
                            ) : (
                                <BsLock
                                    style={{
                                        fontSize: '16pt',
                                        color: 'red',
                                    }}
                                />
                            )}
                        </Link>
                    </CellWrapper>
                ),
                disableFilters: true,
                disableSortBy: true,
            },
            ...(getSDWT(process.env.REACT_APP_DEV_MODE_KEY, process.env.REACT_APP_DEV_MODE_VALUE)
                ? [
                      {
                          Header: '#',
                          accessor: 'direct-auth',
                          Cell: ({ row: { original } }) => (
                              <CellWrapper position="center">
                                  <Button
                                      variant="outline-secondary"
                                      className="button-input-group-effect gap-5marginpx rounded-circle"
                                      id="basic-addon33"
                                      onClick={() => DirectAuth(original)}
                                  >
                                      <FontAwesomeIcon
                                          icon={faRightFromBracket}
                                          size="xs"
                                          style={{ color: '#376ca9' }}
                                      />
                                  </Button>
                              </CellWrapper>
                          ),
                          disableFilters: true,
                          disableSortBy: true,
                      },
                  ]
                : []),
        ],
        [users],
    );

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Users</Breadcrumb.Item>
            </Breadcrumb>
            <div className="d-flex justify-content-between align-items-center py-2">
                <div className="d-flex justify-content-start gap-1">
                    <h2>Users</h2>
                    <DWTSecretArea />
                </div>
                <Link to="/admin/user/create">
                    <button className="btn btn-outline-primary btn-sm">
                        <AiOutlinePlusCircle />
                        <span className="ml-1">New</span>
                    </button>
                </Link>
            </div>
            <TableTemplate
                columns={columns}
                data={users}
                options={{
                    pagination: true,
                    showGlobalFilter: true,
                    debugData: false,
                    showFiltersRowByColumn: true,
                    rowSelecting: false,
                    hiddenColumns: ['userId'],
                }}
            />
            <CustomModal title="Changer de compte" size="lg" show={showForcingAuth} handleClose={closeDWTModal}>
                {forcedAuth ? (
                    <ForcingAuth data={forcedAuth} setData={setForcedAuth} closeModal={closeDWTModal} />
                ) : (
                    <></>
                )}
            </CustomModal>
        </>
    );
};

export default Apps;
